import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import integrationTrackingService from "app/pages/sales-intelligence/services/tracking/integrationTrackingService";
import { unknownToFetchError } from "app/pages/sales-intelligence/utils/errors/fetchError";

import type { Integration } from "../../../../sub-modules/management/types";
import { CRM_STATUS_CONFIG } from "../../constants/crm";
import { manageIntegrationsQueryKeys } from "../key-factory/factory";

export const useDisconnectCRMIntegrationMutation = (integrationName: Integration) => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();

    const crmConfig = CRM_STATUS_CONFIG[integrationName];

    return useMutation({
        mutationKey: manageIntegrationsQueryKeys.disconnectIntegration(),
        async mutationFn() {
            dispatch(crmConfig.disconnectAction.request());

            try {
                await crmConfig.disconnectApi();

                dispatch(crmConfig.disconnectAction.success());
            } catch (error) {
                dispatch(crmConfig.disconnectAction.failure(unknownToFetchError(error)));
                throw error;
            }
        },
        async onSuccess() {
            integrationTrackingService.trackDisconnection(integrationName);

            await queryClient.invalidateQueries({
                queryKey: manageIntegrationsQueryKeys.byIntegration(integrationName),
            });
        },
    });
};
